import { createLogger } from './logger'

export const logger = createLogger()

export { createLogger }
